import { render, staticRenderFns } from "./ManualLinks.vue?vue&type=template&id=71d7d7b3&scoped=true"
import script from "./ManualLinks.vue?vue&type=script&lang=js"
export * from "./ManualLinks.vue?vue&type=script&lang=js"
import style0 from "./ManualLinks.vue?vue&type=style&index=0&id=71d7d7b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d7d7b3",
  null
  
)

export default component.exports